// extracted by mini-css-extract-plugin
export var categories = "index-module--categories--djJDR";
export var container = "index-module--container--ofFQt";
export var h1 = "index-module--h1--QN2Fv";
export var isActive = "index-module--isActive--PMzPz";
export var tabBar = "index-module--tabBar--mSjVe";
export var tag = "index-module--tag--vIy7e";
export var tags = "index-module--tags--ocO+Z";
export var title = "index-module--title--n3yb8";